// helpers
import { log } from 'shared/helpers/newRelic';
import { getWebAppType } from 'shared/helpers/deviceType/webAppType';

// constants
import { WEB_APP_TYPE } from 'shared/constants';
import { TAG_IDENTIFIER } from 'shared/helpers/newRelic/constants';

/**
 * Contract for Size Guide → App communication:
 *
 * 1. onSizeSelected(payload) — called when user selects a size in the size guide
 *    payload: { sizeName: string, sizeId: string, sku: string, isOutOfStock: boolean }
 *
 * 2. onAddToBag(payload) — called when user taps "Add to Bag" in the size guide
 *    payload: { sizeName: string, sizeId: string, sku: string, vendorId: string, vendorType: string }
 *
 * 3. onNotifyMe(payload) — called when user taps "Notify Me" for an OOS size
 *    payload: { sizeName: string, sizeId: string, sku: string }
 */

interface SizeSelectedPayload {
    sizeName: string;
    sizeId: string;
    sku: string;
    isOutOfStock: boolean;
}

interface AddToBagPayload {
    sizeName: string;
    sizeId: string;
    sku: string;
    vendorId: string;
    vendorType: string;
}

interface NotifyMePayload {
    sizeName: string;
    sizeId: string;
    sku: string;
}

const callNativeApp = (functionName: string, payload: object) => {
    const type = getWebAppType();
    try {
        if (WEB_APP_TYPE.ANDROID === type) {
            if ((window as any).AndroidFunction && typeof (window as any).AndroidFunction[functionName] === 'function') {
                (window as any).AndroidFunction[functionName](JSON.stringify(payload));
            }
        } else if (WEB_APP_TYPE.IOS === type) {
            if ((window as any).webkit?.messageHandlers && (window as any).webkit.messageHandlers[functionName]) {
                (window as any).webkit.messageHandlers[functionName].postMessage(payload);
            }
        }
    } catch (error) {
        log({
            errTitle: `Error in SizeGuide app callback: ${functionName}`,
            error,
            tags: { [TAG_IDENTIFIER.MODULE]: 'Size Guide' },
        });
    }
};

export const notifyAppSizeSelected = (payload: SizeSelectedPayload) => {
    callNativeApp('onSizeGuideSelection', payload);
};

export const notifyAppAddToBag = (payload: AddToBagPayload) => {
    callNativeApp('onSizeGuideAddToBag', payload);
};

export const notifyAppNotifyMe = (payload: NotifyMePayload) => {
    callNativeApp('onSizeGuideNotifyMe', payload);
};
